export default __webpack_public_path__ + "static/media/Blueberry Smoothie -  proportioned_170.54506c2f.jpg";